// extracted by mini-css-extract-plugin
module.exports =  {"promos":"a10a3f92e9--promos--GceOc"};